import { Injectable } from '@angular/core';
import { I18nService } from '@app/core';
import { ApiService } from './utility/api.service';



@Injectable()
export class AuthService {

  private loggedInStatus = false;
  constructor(private http: ApiService,
    private i18nService: I18nService) { }

  setLoggedIn(value: boolean) {
    this.loggedInStatus = value;
  }
  get isLoggedIn() {
    return this.loggedInStatus;
  }

 async getuserDetails(user: string, password: string) {
    var req: any = {};
    req['member_no'] = user;
    req['password'] = password;
    var data: any = {};
    data =await this.http.postnotauthen('account', 'GetMenu', req);
    return data;
    //return  this.http.get<MemberObj>(url)
  }




}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts